// extracted by mini-css-extract-plugin
export default {"danger":"#f13a42","dangerLight":"#eb989e","flex":"CustomDestructive_flex__JpkX8","switch":"CustomDestructive_switch__w8dDN"};